import * as coll from "typescript-collections";
import MPointMapper from "../mapping/mpointMapper";
import Hull from "../models/metMap/hull";
import MPointMarker from "../models/metMap/viewModels/mPointMarker";
class ViewState {
    //static kommer inte funka om det är mer en än karta på sidan
    static init(dotNetRef, rawMpoints) {
        ViewState.mPointMarkers = new Array();
        ViewState.mapMPoints = new Array();
        ViewState.hulls = new Map();
        ViewState.dotNetRef = dotNetRef;
        let i = 0;
        rawMpoints.forEach(m => {
            const mpoint = MPointMapper.parse(m);
            ViewState.mapMPoints.push(mpoint);
            if (m.hullFolder) {
                if (!ViewState.hulls.get(m.hullFolder.treeNodeId))
                    ViewState.hulls.set(m.hullFolder.treeNodeId, new Hull(m.hullFolder.treeNodeId, m.hullFolder.name, m.hullFolder.color));
            }
            const marker = new MPointMarker();
            marker._mpoint = mpoint;
            marker.mpointId = mpoint.id;
            marker.indexKey = i++;
            marker.selectMode = m.selectMode;
            ViewState.mPointMarkers.push(marker);
        });
    }
}
ViewState.mapMPoints = new Array();
//public static get map_mpoints() { return ViewState.mapMPoints ?? new Array<MPoint>();}
ViewState.mPointMarkers = new Array();
ViewState.hulls = new Map();
ViewState.blazorIcons = new Map();
/*powmon*/
/*pq4cast*/
ViewState.blockGetForecasts = false;
ViewState.historyMPointsCache = new coll.Queue(); //flytta?
export default ViewState;
